// extracted by mini-css-extract-plugin
export default {"center":"Cell_center__6sqtG","marginHorizontal":"Cell_marginHorizontal__80+nE","marginHorizontalChip":"Cell_marginHorizontalChip__9B02l","displayFlex":"Cell_displayFlex__OGkmD"};